import type { ThreadData } from '@liveblocks/client'

import type { EventProperties } from '@/lib/analytics/events'

import { CommentsLoadError } from '@/components/shared/comment/comments-load-error'

import { AssessmentCommentThread } from './assessment-comment-thread'
import { AssessmentCommentsEmptyState } from './assessment-comments-empty-state'
import { AssessmentCommentsSkeleton } from './assessment-comments-skeleton'
import { ASSESSMENT_COMMENTS_LABELS, noSearchResultsMessage } from './labels'

type AssessmentCommentsFeedProps = {
  assessmentId: string
  isLoading: boolean
  hasError: boolean
  threadCount: number
  visibleThreads: ThreadData[]
  search: string
  readOnly?: boolean
  highlightedCommentId?: string | null
  trackingProps?: EventProperties
}

export const AssessmentCommentsFeed = ({
  assessmentId,
  isLoading,
  hasError,
  threadCount,
  visibleThreads,
  search,
  readOnly,
  highlightedCommentId,
  trackingProps,
}: AssessmentCommentsFeedProps) => {
  if (isLoading) return <AssessmentCommentsSkeleton />
  if (hasError) return <CommentsLoadError />

  if (threadCount === 0) {
    return <AssessmentCommentsEmptyState />
  }

  if (visibleThreads.length === 0) {
    return (
      <p className='text-main-foreground-secondary text-body-default'>
        {search ? noSearchResultsMessage(search) : ASSESSMENT_COMMENTS_LABELS.noFilterResults}
      </p>
    )
  }

  return (
    <>
      {visibleThreads.map((thread) => (
        <AssessmentCommentThread
          key={thread.id}
          assessmentId={assessmentId}
          thread={thread}
          readOnly={readOnly}
          highlightedCommentId={highlightedCommentId}
          trackingProps={trackingProps}
        />
      ))}
    </>
  )
}
